import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";

// Polyfill for Promise.withResolvers to avoid errors in old mobile browsers
if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function <T>() {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: any) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve: resolve!, reject: reject! };
  };
}

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export interface SharedPDFViewerProps {
  fileUrl: string;
  className?: string;
}

export const SharedPDFViewer: React.FC<SharedPDFViewerProps> = ({ fileUrl, className }) => {
  return (
    <div style={{ height: "100%" }}>
      <Document
        className={className}
        file={fileUrl}
        externalLinkTarget="_blank"
        onLoadError={(error) => console.error("Error loading PDF:", error)}
        loading={
          <div
            style={{
              width: "100%",
              height: "14rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "red",
            }}
          >
            <ButtonLib
              shape="ghost"
              isLoading
              ariaLabel="Loading PDF"
              dataQA="pdf-loading-button"
            />
          </div>
        }
      >
        <Page
          pageNumber={1}
          renderAnnotationLayer={false}
          renderTextLayer={false}
        />
      </Document>
    </div>
  );
};
